export enum MuscleGrowthMain {
  BareMinimum = 0,
  Balanced = 1,
  Custom = 2 /** Use the preference table iff this option _or higher_ is selected. */,
  LowerBody = 3,
}

export enum OneMuscleGrowthValue {
  Shrink = -1,
  Maintain = 0,
  Maximize = 1,
}

// keep this in sync with MuscleGrowthPreferenceKeys!
export interface MuscleGrowthPreferenceTable {
  glutes: OneMuscleGrowthValue;
  glutemed: OneMuscleGrowthValue;
  quads: OneMuscleGrowthValue;
  hams: OneMuscleGrowthValue;
  calves: OneMuscleGrowthValue;
  shoulders: OneMuscleGrowthValue;
  chest: OneMuscleGrowthValue;
  lats: OneMuscleGrowthValue;
  traps: OneMuscleGrowthValue;
  triceps: OneMuscleGrowthValue;
  biceps: OneMuscleGrowthValue;
  abs: OneMuscleGrowthValue;
}
// keep this in sync with MuscleGrowthPreferenceTable!
export const MuscleGrowthPreferenceKeys = [
  'glutes',
  'glutemed',
  'quads',
  'hams',
  'calves',
  'shoulders',
  'chest',
  'lats',
  'traps',
  'triceps',
  'biceps',
  'abs',
];

export type MuscleCustomizationGroup = keyof MuscleGrowthPreferenceTable;

export function isOneMuscleGrowthValueValid(v: OneMuscleGrowthValue): boolean {
  return [OneMuscleGrowthValue.Maintain, OneMuscleGrowthValue.Maximize, OneMuscleGrowthValue.Shrink].some(x => x == v);
}

export function isMuscleGrowthPreferenceTableValid(t: MuscleGrowthPreferenceTable): boolean {
  let keys = Object.keys(t);
  if (keys.length != MuscleGrowthPreferenceKeys.length) {
    return false;
  }
  for (let k of keys) {
    if (!MuscleGrowthPreferenceKeys.some(x => x === k)) {
      return false;
    }
    if (!isOneMuscleGrowthValueValid(t[k])) {
      return false;
    }
  }
  return true;
}

export function getSimpleMuscleGrowthPreferenceTable(v: OneMuscleGrowthValue): MuscleGrowthPreferenceTable {
  return {
    chest: v,
    shoulders: v,
    traps: v,
    lats: v,
    biceps: v,
    triceps: v,
    quads: v,
    hams: v,
    glutes: v,
    glutemed: OneMuscleGrowthValue.Maintain, // Balanced+Female and LowerBody presets override to Maximize, Balanced+Male overrides to Shrink — see design-docs/muscle-growth-preference.md
    calves: v,
    abs: OneMuscleGrowthValue.Maintain, // abs are only exercised if customized
  };
}
